import { epoch, utc } from '../../util/datetime';
import { toUUID } from '../../util/transform';
import type { IOwnership } from './Ownership.interface';

export default class Ownership {
  idContact: string;
  percent: number;
  timeStamp: number;
  isActive: boolean;

  static build = (data: IOwnership) => new Ownership(data);
  static blank = (idContact: string, percent: number) =>
    new Ownership({ idContact, percent, isActive: true });

  /**
   * Constructor
   * @param {IOwnership} data
   */
  constructor(data?: IOwnership) {
    this.idContact = toUUID(data?.idContact);
    this.percent = parseFloat(data?.percent || 0);
    this.timeStamp = epoch(utc(data.timeStamp));
    this.isActive = data?.isActive === true;
  }
}
